<template>
  <v-dialog
    v-model="show"
    max-width="500px"
    scrollable
    persistent
  >
    <v-card :loading="formProcessing">
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-form>
            <v-row>
              <v-col
                cols="12"
                md="12"
              >
                <v-text-field
                  v-model="employerName"
                  required
                  label="Employer Name"
                  :error-messages="employerNameErrors"
                  @input="v$.employerName.$touch()"
                  @blur="v$.employerName.$touch()"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer />

        <v-btn
          color="blue darken-1"
          text
          :disabled="formProcessing"
          @click="close()"
        >
          Cancel
        </v-btn>

        <v-btn
          color="blue darken-1"
          text
          :disabled="formProcessing"
          @click="save()"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    editedItem: {
      type: Object,
      default() {
        return {
          id: null,
          employerName: '',
        };
      },
    },
  },
  setup() { return { v$: useVuelidate() }; },
  validations: {
    employerName: {
      required,
    },
  },
  data() {
    return {
      valid: false,
      id: null,
      employerName: '',
      formProcessing: false,
    };
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    formTitle() {
      const newOrUpdate = this.isNewItem ? 'New' : 'Update';
      return `${newOrUpdate} Bad Employer`;
    },
    isNewItem() {
      return !this.editedItem.id;
    },
    employerNameErrors() {
      const errors = [];

      if (!this.v$.employerName.$dirty) {
        return errors;
      }

      if (this.v$.employerName.required.$invalid) {
        errors.push('Employer Name is required.');
      }

      return errors;
    },
  },
  watch: {
    editedItem() {
      this.id = this.editedItem.id;
      this.employerName = this.editedItem.employer_name;
    },
  },
  methods: {
    ...mapActions('notification', ['setNotification']),

    save() {
      this.v$.$touch();

      if (!this.v$.$invalid) {
        this.formProcessing = true;
        let request = '';
        const data = { employerName: this.employerName };

        if (this.isNewItem) {
          request = this.$axios.post('/api/v1/bad-employer', data);
        } else {
          request = this.$axios.put(`/api/v1/bad-employer/${this.editedItem.id}`, data);
        }

        request
          .then((res) => {
            this.$emit('item-saved');

            this.setNotification({
              message: `${res.data.employer_name} has been saved.`,
              color: 'green',
            });
          })
          .catch(() => {
            this.setNotification({
              message: 'There was an error processing your request.',
              color: 'red',
            });
          })
          .then(() => {
            this.formProcessing = false;

            this.close();
          });
      }
    },
    close() {
      this.v$.$reset();

      this.$emit('close-modal');

      this.employerName = '';
    },
  },
};
</script>

<style></style>
